import { createThemeOverrides } from '../themeOverrides/';
import { type Theme } from '@mui/material/styles/createTheme';
import { createContext, useState, ReactNode } from 'react';
import { ThemeProvider } from '@mui/material';
import { palette } from '../themeOverrides/palette';
import { createTheme } from '@mui/material/styles';
import { theme } from '../';

const ThemeContext = createContext<[Theme, () => void]>([theme, () => { }]);

const getDefaultTheme = (): Theme => {
  const themeOverrides = createThemeOverrides();

  const themeToConfig = {
    ...themeOverrides,
    palette: {
      ...themeOverrides.palette,
      primary: palette.defaultPrimary,
      secondary: palette.defaultSecondary,
    },
  };
  return createTheme(themeToConfig);
};

interface ThemeProviderContextProps {
  children: ReactNode;
}

const ThemeProviderContext = ({ children }: ThemeProviderContextProps) => {
  const [currentTheme] = useState(() => {
    return getDefaultTheme();
  });

  return (
    <ThemeContext.Provider value={[currentTheme, () => {}]}>
      <ThemeProvider theme={currentTheme}>
        {children}
      </ThemeProvider>
    </ThemeContext.Provider>
  );
};

export { ThemeProviderContext, ThemeContext };
